/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.personal.payment', {
            parent: 'member.personal',
            url: '/member/personal/payment',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.member.payment'
            },
            views: {
                'personal@member.personal': {
                    templateUrl: 'app/member/personal/payment/payment.html',
                    controller: 'MemberPaymentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
